/**
 * Whether a failure is the browser's generic "the request did not complete":
 * offline, DNS failure, CORS rejection, or a connection dropped mid-response.
 * Each engine words it differently, and none of them expose anything more
 * specific.
 */
export function isNetworkError(err: unknown): err is TypeError {
  return (
    err instanceof TypeError &&
    (err.message.includes("Failed to fetch") || // Chromium
      err.message.includes("NetworkError") || // Firefox
      err.message.includes("Load failed")) // Safari
  );
}
